import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { EMPTY_LANGUAGE, EMPTY_LANGUAGE_LIST_CRITERIA } from "../constant/languageConstant";
import { Language } from "../objects/language";
import { LanguageListCriteria } from "../objects/languageListCriteria";
import { LanguageState } from "../objects/languageState";


const initialState: LanguageState = {
    language_list: [],
    language_list_loading: false,
    language_list_count: 0,
    language_list_criteria: EMPTY_LANGUAGE_LIST_CRITERIA,
    language: EMPTY_LANGUAGE,
};

const updateLanguageListReducer = (state: LanguageState, action: PayloadAction<Language[]>): LanguageState => ({
    ...state, language_list: action.payload
});
const updateOneLanguageListReducer = (state: LanguageState, action: PayloadAction<Language>): LanguageState => ({
    ...state, language_list: state.language_list.map(langue => langue.id === action.payload.id? action.payload: langue)
});
const updateLanguageListCriteriaReducer = (state: LanguageState, action: PayloadAction<LanguageListCriteria>): LanguageState => ({
    ...state, language_list_criteria: action.payload
});
const updateLanguageReducer = (state: LanguageState, action: PayloadAction<Language>): LanguageState => ({
    ...state, language: { ...action.payload }
});
const updateLanguageListLoadingReducer = (state: LanguageState, action: PayloadAction<boolean>): LanguageState => ({
    ...state, language_list_loading: action.payload
});
const updateLanguageListCountReducer = (state: LanguageState, action: PayloadAction<number>): LanguageState => ({
    ...state, language_list_count: action.payload
});

export const language = createSlice({
    name: 'language',
    initialState,
    reducers: {
        updateLanguageList: updateLanguageListReducer,
        updateOneLanguageList: updateOneLanguageListReducer,
        updateLanguageListCriteria: updateLanguageListCriteriaReducer,
        updateLanguage: updateLanguageReducer,
        updateLanguageListLoading: updateLanguageListLoadingReducer,
        updateLanguageListCount: updateLanguageListCountReducer
    },
});

export const {
    updateLanguageList,
    updateOneLanguageList,
    updateLanguageListCriteria,
    updateLanguage,
    updateLanguageListLoading,
    updateLanguageListCount
} = language.actions;